import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined';
import {
  Alert,
  Box,
  Button,
  Container,
  Grid,
  Link,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useState } from 'react';

import InformationSubMenu from '@/components/nav/InformationSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
// import type { LayoutWrapperContents } from '@/types/LayoutWrapperContents';

const Form1099Kansas = () => {
  const [open, setOpen] = useState(false);

  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Extend your business tax return deadline with Form 7004.`,
  //   SubHeading:
  //     'E-file now and get more time to ensure accuracy. File now for peace of mind.',
  //   CtaText: 'E-file Form 7004 Now',
  //   CtaSubHeading: `Takes 3 steps and less than 5 minutes`,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=sticky`,
  //   isActive: true,
  // };

  return (
    <AppLayout
      //  LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="E-File Kansas 1099 Forms Easily with TaxZerone | $0.99 per Form"
          description="E-File Kansas 1099 forms for just $0.99 each with TaxZerone. Stay compliant with state requirements and file securely in minutes. Start e-filing today!"
          keywords=" "
          canonical="form-1099-state-filing/kansas-filing-requirements/"
          jsonLdPricing="0.99"
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="57448"
          ogShareImg="assets/images/information-share-img.png"
        />
      }
    >
      <InformationSubMenu />
      <ComingSoonPopup open={open} setOpen={setOpen} />

      {/* <Container maxWidth="md">
        <Box sx={{ px: 2, mt: 3, mx: 0 }}>
          <Alert
            severity="warning"
            icon={<WarningIcon sx={{ fontSize: 30 }} />}
            sx={{ borderRadius: 3 }}
          >
            <AlertTitle
              sx={{ fontSize: { xs: 18, sm: 20, md: 22 }, fontWeight: 600 }}
            >
              Attention! Final Day to E-File Form W-2!
            </AlertTitle>

            <Typography
              variant="body1"
              sx={{ fontSize: { xs: 16, sm: 17, md: 18 } }}
            >
              Don&apos;t miss the deadline! Today is the <b>Last Day</b> to
              Submit Your <b>Form W-2</b> Electronically!
            </Typography>
          </Alert>
        </Box>
      </Container> */}
      <Container maxWidth="xl" component="section">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/1099-ks-landing-img.webp" />
                <source srcSet="/assets/images/1099-ks-landing-img.png" />
                <img
                  src="/assets/images/1099-ks-landing-img.png"
                  alt="E-File Your Kansas 1099 Forms With Ease"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>

          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                E-File Your{' '}
                <span className="highlight-container">
                  <span className="highlight"> Kansas</span>
                </span>{' '}
                1099 Forms With Ease
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                }}
              >
                TaxZerone simplifies 1099 filing for the 2025 tax year. Stay
                compliant with Kansas state requirements and file securely in
                minutes.
              </Typography>
              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box sx={{ textAlign: 'center', mr: { xs: 0, md: 4 } }}>
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1099ks`}
                  >
                    Start Filing Now!{' '}
                    {/* <Box
                      component={'span'}
                      sx={{ ml: 1, color: '#eaff00', fontWeight: 700 }}
                    >
                      Your W-2 Today!
                    </Box> */}
                  </Button>
                </Box>
              </Stack>
            </Box>
          </Box>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/1099-ks-landing-img-sm.webp" />
                <source srcSet="/assets/images/1099-ks-landing-img-sm.png" />
                <img
                  src="/assets/images/1099-ks-landing-img-sm.png"
                  alt="E-File Your Kansas 1099 Forms With Ease"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container
          maxWidth="lg"
          sx={{
            my: { xs: 0, md: 3, lg: 5 },
            py: { xs: 2, sm: 3, md: 3, lg: 3 },
            borderRadius: { xs: 0, md: 4 },
            mx: { xs: 0, md: 3, lg: 'auto' },
          }}
          className="gradient-bg"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 3 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Box sx={{ width: '100%' }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 30, md: 30, sm: 26, xs: 22 },
                  fontWeight: 500,
                  mb: 0,
                  textAlign: 'left',
                  lineHeight: 1.5,
                }}
              >
                Affordable Pricing
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 22, md: 20, sm: 18, xs: 16 },
                  fontWeight: 400,
                  color: '#f3f3f3',
                  mb: 0,
                  textAlign: 'left',
                }}
              >
                E-File your Kansas 1099 forms for just{' '}
                <Box
                  component="strong"
                  sx={{
                    color: '#ffe400',
                    fontSize: { xs: 24, sm: 22 },
                  }}
                >
                  $0.99 per form
                </Box>{' '}
                —simple, transparent, and budget-friendly!
              </Typography>
            </Box>
            <Box
              sx={{
                width: '100%',
                maxWidth: { xs: '100', sm: 250, md: 280 },
                textAlign: 'center',
                fontSize: 18,
                lineHeight: 1.2,
              }}
            >
              <Button
                size="large"
                variant="contained"
                href="/pricing/#informationreturns"
                sx={{
                  boxShadow: 'none',
                  borderRadius: 2,
                  mb: 0.5,
                  textTransform: 'none',
                  backgroundColor: '#fff',
                  color: '#0a7581',
                  '&:hover, &:focus, &:active': {
                    color: '#fff',
                    backgroundColor: '#172b6b',
                  },
                }}
              >
                See Pricing
              </Button>
              {/* <Typography
                variant="body2"
                sx={{ mt: 0, mb: 0, fontSize: { xs: 11, sm: 14 } }}
              >
                For your return volume
              </Typography> */}
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Container
        component="section"
        maxWidth="lg"
        sx={{ pt: 6, pb: 6, textAlign: 'center' }}
      >
        <Grid container spacing={2} sx={{ pt: 2, pb: 2 }}>
          <Grid size={12} sx={{ textAlign: 'center' }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: { md: 3, sm: 1, xs: 0 },
                pt: { md: 0, sm: 3 },
                textAlign: { md: 'center', sm: 'center' },
              }}
            >
              Kansas 1099 Filing Requirements
            </Typography>
            <Typography
              variant="body1"
              id="nec"
              sx={{ mb: { md: 3, sm: 3, xs: 16 } }}
            >
              Stay compliant with Kansas&apos;s 1099 filing requirements by
              understanding the required forms, reporting thresholds,{' '}
              <Hidden smDown>
                <br />
              </Hidden>
              submission methods, and deadlines. Ensure accurate and timely
              filing for:
            </Typography>
            <Hidden smDown>
              <Stack
                direction="row"
                spacing={2}
                sx={{
                  textAlign: 'center',
                  justifyContent: 'center',
                  maxWidth: '100%',
                  alignSelf: 'center',
                  m: 0,
                }}
              >
                <Link href="#nec" sx={{ textDecoration: 'none' }}>
                  <Paper
                    variant="outlined"
                    sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                  >
                    <Typography
                      variant="h4"
                      sx={{ fontSize: '14px !important', fontWeight: 600 }}
                    >
                      1099-NEC
                    </Typography>
                  </Paper>
                </Link>
                <Link href="#misc" sx={{ textDecoration: 'none' }}>
                  <Paper
                    variant="outlined"
                    sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                  >
                    <Typography
                      variant="h4"
                      sx={{ fontSize: '14px !important', fontWeight: 600 }}
                    >
                      1099-MISC
                    </Typography>
                  </Paper>
                </Link>
                <Link href="#1099b" sx={{ textDecoration: 'none' }}>
                  <Paper
                    variant="outlined"
                    sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                  >
                    <Typography
                      variant="h4"
                      sx={{ fontSize: '14px !important', fontWeight: 600 }}
                    >
                      1099-B
                    </Typography>
                  </Paper>
                </Link>
                <Link href="#div" sx={{ textDecoration: 'none' }}>
                  <Paper
                    variant="outlined"
                    sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                  >
                    <Typography
                      variant="h4"
                      sx={{ fontSize: '14px !important', fontWeight: 600 }}
                    >
                      1099-DIV
                    </Typography>
                  </Paper>
                </Link>
                <Link href="#1099g" sx={{ textDecoration: 'none' }}>
                  <Paper
                    variant="outlined"
                    sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                  >
                    <Typography
                      variant="h4"
                      sx={{ fontSize: '14px !important', fontWeight: 600 }}
                    >
                      1099-G
                    </Typography>
                  </Paper>
                </Link>
                <Hidden mdDown>
                  <Link href="#int" sx={{ textDecoration: 'none' }}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                    >
                      <Typography
                        variant="h4"
                        sx={{ fontSize: '14px !important', fontWeight: 600 }}
                      >
                        1099-INT
                      </Typography>
                    </Paper>
                  </Link>
                  <Link href="#1099k" sx={{ textDecoration: 'none' }}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                    >
                      <Typography
                        variant="h4"
                        sx={{ fontSize: '14px !important', fontWeight: 600 }}
                      >
                        1099-K
                      </Typography>
                    </Paper>
                  </Link>
                  <Link href="#oid" sx={{ textDecoration: 'none' }}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                    >
                      <Typography
                        variant="h4"
                        sx={{ fontSize: '14px !important', fontWeight: 600 }}
                      >
                        1099-OID
                      </Typography>
                    </Paper>
                  </Link>
                  <Link href="#1099r" sx={{ textDecoration: 'none' }}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                    >
                      <Typography
                        variant="h4"
                        sx={{ fontSize: '14px !important', fontWeight: 600 }}
                      >
                        1099-R
                      </Typography>
                    </Paper>
                  </Link>
                  <Link href="#w2g" sx={{ textDecoration: 'none' }}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                    >
                      <Typography
                        variant="h4"
                        sx={{ fontSize: '14px !important', fontWeight: 600 }}
                      >
                        W-2G
                      </Typography>
                    </Paper>
                  </Link>
                </Hidden>
              </Stack>
            </Hidden>
            <Hidden mdUp smDown>
              <Stack
                direction="row"
                spacing={2}
                sx={{
                  textAlign: 'center',
                  justifyContent: 'center',
                  maxWidth: '100%',
                  mt: 2,
                }}
              >
                <Link href="#int" sx={{ textDecoration: 'none' }}>
                  <Paper
                    variant="outlined"
                    sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                  >
                    <Typography
                      variant="h4"
                      sx={{ fontSize: '14px !important', fontWeight: 600 }}
                    >
                      1099-INT
                    </Typography>
                  </Paper>
                </Link>
                <Link href="#1099k" sx={{ textDecoration: 'none' }}>
                  <Paper
                    variant="outlined"
                    sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                  >
                    <Typography
                      variant="h4"
                      sx={{ fontSize: '14px !important', fontWeight: 600 }}
                    >
                      1099-K
                    </Typography>
                  </Paper>
                </Link>
                <Link href="#oid" sx={{ textDecoration: 'none' }}>
                  <Paper
                    variant="outlined"
                    sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                  >
                    <Typography
                      variant="h4"
                      sx={{ fontSize: '14px !important', fontWeight: 600 }}
                    >
                      1099-OID
                    </Typography>
                  </Paper>
                </Link>
                <Link href="#1099r" sx={{ textDecoration: 'none' }}>
                  <Paper
                    variant="outlined"
                    sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                  >
                    <Typography
                      variant="h4"
                      sx={{ fontSize: '14px !important', fontWeight: 600 }}
                    >
                      1099-R
                    </Typography>
                  </Paper>
                </Link>
                <Link href="#w2g" sx={{ textDecoration: 'none' }}>
                  <Paper
                    variant="outlined"
                    sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                  >
                    <Typography
                      variant="h4"
                      sx={{ fontSize: '14px !important', fontWeight: 600 }}
                    >
                      W-2G
                    </Typography>
                  </Paper>
                </Link>
              </Stack>
            </Hidden>
          </Grid>
          <Grid
            size={12}
            sx={{
              textAlign: 'center',
              mb: 4,
              position: { xs: 'relative', sm: 'static' },
            }}
          >
            <Box
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: { xs: 'flex', sm: 'grid', md: 'grid' },
                gridTemplateColumns: 'auto auto ',
                columnGap: 1,
                placeContent: 'start',
                m: { xs: 3, sm: 0 },
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  justifyContent: 'center',
                  alignContent: 'center',
                  borderRadius: '50%',
                  backgroundColor: '#efefef',
                  height: 150,
                  width: 150,
                  position: { xs: 'absolute', sm: 'relative', md: 'relative' },
                  left: { md: 55, sm: 40, xs: 90 },
                  zIndex: 2,
                  top: { xs: -80, sm: 0 },
                  p: 3,
                  m: '0',
                  boxShadow:
                    'rgba(154, 154, 163, 0.25) 0px 30px 50px -12px inset, rgba(255, 255, 255, 0.1) 0px 18px 26px -18px inset',
                }}
              >
                <Box
                  sx={{
                    width: '34px !important',
                    height: '27px !important',
                    m: 'auto',
                    display: 'flex',
                    textAlign: 'center',
                    justifyContent: 'center',
                    mb: 0.5,

                    '& .state-flag': {
                      height: '100%',
                      width: '100%',
                    },
                  }}
                >
                  <img
                    srcSet="/assets/images/state-flag/kansas-flag.svg"
                    loading="lazy"
                    alt="kansas"
                    width="100%"
                    height="100%"
                    className="state-flag"
                  />
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 700,
                    justifyContent: 'center',
                    alignItems: 'center',
                    m: 0,
                  }}
                >
                  1099-NEC
                </Typography>
              </Box>
              <Box
                sx={{
                  backgroundColor: '#f0f3ff',

                  borderRadius: 4,
                  justifyContent: { xs: 'center' },
                  position: 'relative',
                  width: { xs: 331, sm: 'auto' },
                  right: { xs: 23, sm: 'auto' },
                }}
              >
                <Box
                  component="div"
                  sx={{ mb: 0, mx: 4, position: 'relative' }}
                  className="rectange-state rectange-state-left"
                >
                  <TableContainer
                    sx={{
                      borderRadius: 2,
                      p: 2,
                      zIndex: 2,
                      position: 'relative',
                    }}
                  >
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow sx={{}}>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          />

                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            Kansas State Tax is Withheld
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            Kansas State Tax is not Withheld
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody sx={{}}>
                        <TableRow sx={{ backgroundColor: 'transparent' }}>
                          <TableCell
                            sx={{
                              backgroundColor: 'transparent',
                              textAlign: 'center',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Taxes / Payments
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            More than $0 in taxes
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            $600 or more in payments
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Filing Method
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Additional Form
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Form KW-3 <br />
                            (Annual Withholding Tax Return)
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            Form KW-3 <br />
                            (Annual Withholding Tax Return)
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                            id="misc"
                          >
                            Due Date
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid
            size={12}
            sx={{
              textAlign: 'center',
              mt: { xs: 6, sm: 0 },
              mb: 4,
              position: { xs: 'relative', sm: 'static' },
            }}
          >
            <Box
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: { xs: 'flex', sm: 'grid', md: 'grid' },
                gridTemplateColumns: 'auto auto ',
                columnGap: 1,
                placeContent: 'start',
                m: { xs: 3, sm: 0 },
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  justifyContent: 'center',
                  alignContent: 'center',
                  borderRadius: '50%',
                  backgroundColor: '#efefef',
                  height: 150,
                  width: 150,
                  position: { xs: 'absolute', sm: 'relative', md: 'relative' },
                  left: { md: 55, sm: 40, xs: 90 },
                  zIndex: 2,
                  top: { xs: -80, sm: 0 },
                  p: 3,
                  m: '0',
                  boxShadow:
                    'rgba(154, 154, 163, 0.25) 0px 30px 50px -12px inset, rgba(255, 255, 255, 0.1) 0px 18px 26px -18px inset',
                }}
              >
                <Box
                  sx={{
                    width: '34px !important',
                    height: '27px !important',
                    m: 'auto',
                    display: 'flex',
                    textAlign: 'center',
                    justifyContent: 'center',
                    mb: 0.5,
                    // position: 'relative',
                    // mb: 2,

                    // alignSelf: 'center',
                    // textAlign: 'center',

                    '& .state-flag': {
                      // position: 'absolute',
                      height: '100%',
                      width: '100%',
                      // inset: '0px',
                      // color: 'transparent',
                    },
                  }}
                >
                  <img
                    srcSet="/assets/images/state-flag/kansas-flag.svg"
                    loading="lazy"
                    alt="kansas"
                    width="100%"
                    height="100%"
                    className="state-flag"
                  />
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 700,
                    justifyContent: 'center',
                    alignItems: 'center',
                    m: 0,
                    // display: 'flex',
                  }}
                >
                  1099-MISC
                </Typography>
              </Box>
              <Box
                sx={{
                  backgroundColor: '#f0f2f9',

                  borderRadius: 4,
                  justifyContent: { xs: 'center' },
                  position: 'relative',
                  width: { xs: 331, sm: 'auto' },
                  right: { xs: 23, sm: 'auto' },
                }}
              >
                <Box
                  component="div"
                  sx={{ mb: 0, mx: 4, position: 'relative' }}
                  className="rectange-state rectange-state-left"
                >
                  <TableContainer
                    sx={{
                      borderRadius: 2,
                      p: 2,
                      zIndex: 2,
                      position: 'relative',
                    }}
                  >
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow sx={{}}>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          />

                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            Kansas State Tax is Withheld
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            Kansas State Tax is not Withheld
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody sx={{}}>
                        <TableRow sx={{ backgroundColor: 'transparent' }}>
                          <TableCell
                            sx={{
                              backgroundColor: 'transparent',
                              textAlign: 'center',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Taxes / Payments
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            More than $0 in taxes
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            $600 or more in payments
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Filing Method
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Additional Form
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Form KW-3 <br />
                            (Annual Withholding Tax Return)
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            Form KW-3 <br />
                            (Annual Withholding Tax Return)
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                            id="1099b"
                          >
                            Due Date
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid
            size={12}
            sx={{
              textAlign: 'center',
              mb: 4,
              mt: { xs: 6, sm: 0 },
              position: { xs: 'relative', sm: 'static' },
            }}
          >
            <Box
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: { xs: 'flex', sm: 'grid', md: 'grid' },
                gridTemplateColumns: 'auto auto ',
                columnGap: 1,
                placeContent: 'start',
                m: { xs: 3, sm: 0 },
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  justifyContent: 'center',
                  alignContent: 'center',
                  borderRadius: '50%',
                  backgroundColor: '#efefef',
                  height: 150,
                  width: 150,
                  position: { xs: 'absolute', sm: 'relative', md: 'relative' },
                  left: { md: 55, sm: 40, xs: 90 },
                  zIndex: 2,
                  top: { xs: -80, sm: 0 },
                  p: 3,
                  m: '0',
                  boxShadow:
                    'rgba(154, 154, 163, 0.25) 0px 30px 50px -12px inset, rgba(255, 255, 255, 0.1) 0px 18px 26px -18px inset',
                }}
              >
                <Box
                  sx={{
                    width: '34px !important',
                    height: '27px !important',
                    m: 'auto',
                    display: 'flex',
                    textAlign: 'center',
                    justifyContent: 'center',
                    mb: 0.5,

                    '& .state-flag': {
                      height: '100%',
                      width: '100%',
                    },
                  }}
                >
                  <img
                    srcSet="/assets/images/state-flag/kansas-flag.svg"
                    loading="lazy"
                    alt="kansas"
                    width="100%"
                    height="100%"
                    className="state-flag"
                  />
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 700,
                    justifyContent: 'center',
                    alignItems: 'center',
                    m: 0,
                  }}
                >
                  1099-B
                </Typography>
              </Box>
              <Box
                sx={{
                  backgroundColor: '#f0f2f9',

                  borderRadius: 4,
                  justifyContent: { xs: 'center' },
                  position: 'relative',
                  width: { xs: 331, sm: 'auto' },
                  right: { xs: 23, sm: 'auto' },
                }}
              >
                <Box
                  component="div"
                  sx={{ mb: 0, mx: 4, position: 'relative' }}
                  className="rectange-state rectange-state-left"
                >
                  <TableContainer
                    sx={{
                      borderRadius: 2,
                      p: 2,
                      zIndex: 2,
                      position: 'relative',
                    }}
                  >
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow sx={{}}>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          />

                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            Kansas State Tax is Withheld
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            Kansas State Tax is not Withheld
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody sx={{}}>
                        <TableRow sx={{ backgroundColor: 'transparent' }}>
                          <TableCell
                            sx={{
                              backgroundColor: 'transparent',
                              textAlign: 'center',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Taxes / Payments
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            More than $0 in taxes
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            All amounts
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Filing Method
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Additional Form
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Form KW-3 <br />
                            (Annual Withholding Tax Return)
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            Form KW-3 <br />
                            (Annual Withholding Tax Return)
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                            id="div"
                          >
                            Due Date
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid
            size={12}
            sx={{
              textAlign: 'center',
              mb: 4,
              mt: { xs: 6, sm: 0 },
              position: { xs: 'relative', sm: 'static' },
            }}
          >
            <Box
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: { xs: 'flex', sm: 'grid', md: 'grid' },
                gridTemplateColumns: 'auto auto ',
                columnGap: 1,
                placeContent: 'start',
                m: { xs: 3, sm: 0 },
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  justifyContent: 'center',
                  alignContent: 'center',
                  borderRadius: '50%',
                  backgroundColor: '#efefef',
                  height: 150,
                  width: 150,
                  position: { xs: 'absolute', sm: 'relative', md: 'relative' },
                  left: { md: 55, sm: 40, xs: 90 },
                  zIndex: 2,
                  top: { xs: -80, sm: 0 },
                  p: 3,
                  m: '0',
                  boxShadow:
                    'rgba(154, 154, 163, 0.25) 0px 30px 50px -12px inset, rgba(255, 255, 255, 0.1) 0px 18px 26px -18px inset',
                }}
              >
                <Box
                  sx={{
                    width: '34px !important',
                    height: '27px !important',
                    m: 'auto',
                    display: 'flex',
                    textAlign: 'center',
                    justifyContent: 'center',
                    mb: 0.5,
                    // position: 'relative',
                    // mb: 2,

                    // alignSelf: 'center',
                    // textAlign: 'center',

                    '& .state-flag': {
                      // position: 'absolute',
                      height: '100%',
                      width: '100%',
                      // inset: '0px',
                      // color: 'transparent',
                    },
                  }}
                >
                  <img
                    srcSet="/assets/images/state-flag/kansas-flag.svg"
                    loading="lazy"
                    alt="kansas"
                    width="100%"
                    height="100%"
                    className="state-flag"
                  />
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 700,
                    justifyContent: 'center',
                    alignItems: 'center',
                    m: 0,
                    // display: 'flex',
                  }}
                >
                  1099-DIV
                </Typography>
              </Box>
              <Box
                sx={{
                  backgroundColor: '#f0f2f9',

                  borderRadius: 4,
                  justifyContent: { xs: 'center' },
                  position: 'relative',
                  width: { xs: 331, sm: 'auto' },
                  right: { xs: 23, sm: 'auto' },
                }}
              >
                <Box
                  component="div"
                  sx={{ mb: 0, mx: 4, position: 'relative' }}
                  className="rectange-state rectange-state-left"
                >
                  <TableContainer
                    sx={{
                      borderRadius: 2,
                      p: 2,
                      zIndex: 2,
                      position: 'relative',
                    }}
                  >
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow sx={{}}>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          />

                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            Kansas State Tax is Withheld
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            Kansas State Tax is not Withheld
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody sx={{}}>
                        <TableRow sx={{ backgroundColor: 'transparent' }}>
                          <TableCell
                            sx={{
                              backgroundColor: 'transparent',
                              textAlign: 'center',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Taxes / Payments
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            More than $0 in taxes
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            $10 or more, except $600 or more for liquidations
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Filing Method
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Additional Form
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Form KW-3 <br />
                            (Annual Withholding Tax Return)
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            Form KW-3
                            <br /> (Annual Withholding Tax Return)
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                            id="1099g"
                          >
                            Due Date
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid
            size={12}
            sx={{
              textAlign: 'center',
              mb: 4,
              mt: { xs: 6, sm: 0 },
              position: { xs: 'relative', sm: 'static' },
            }}
          >
            <Box
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: { xs: 'flex', sm: 'grid', md: 'grid' },
                gridTemplateColumns: 'auto auto ',
                columnGap: 1,
                placeContent: 'start',
                m: { xs: 3, sm: 0 },
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  justifyContent: 'center',
                  alignContent: 'center',
                  borderRadius: '50%',
                  backgroundColor: '#efefef',
                  height: 150,
                  width: 150,
                  position: { xs: 'absolute', sm: 'relative', md: 'relative' },
                  left: { md: 55, sm: 40, xs: 90 },
                  zIndex: 2,
                  top: { xs: -80, sm: 0 },
                  p: 3,
                  m: '0',
                  boxShadow:
                    'rgba(154, 154, 163, 0.25) 0px 30px 50px -12px inset, rgba(255, 255, 255, 0.1) 0px 18px 26px -18px inset',
                }}
              >
                <Box
                  sx={{
                    width: '34px !important',
                    height: '27px !important',
                    m: 'auto',
                    display: 'flex',
                    textAlign: 'center',
                    justifyContent: 'center',
                    mb: 0.5,

                    '& .state-flag': {
                      height: '100%',
                      width: '100%',
                    },
                  }}
                >
                  <img
                    srcSet="/assets/images/state-flag/kansas-flag.svg"
                    loading="lazy"
                    alt="kansas"
                    width="100%"
                    height="100%"
                    className="state-flag"
                  />
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 700,
                    justifyContent: 'center',
                    alignItems: 'center',
                    m: 0,
                  }}
                >
                  1099-G
                </Typography>
              </Box>
              <Box
                sx={{
                  backgroundColor: '#f0f2f9',

                  borderRadius: 4,
                  justifyContent: { xs: 'center' },
                  position: 'relative',
                  width: { xs: 331, sm: 'auto' },
                  right: { xs: 23, sm: 'auto' },
                }}
              >
                <Box
                  component="div"
                  sx={{ mb: 0, mx: 4, position: 'relative' }}
                  className="rectange-state rectange-state-left"
                >
                  <TableContainer
                    sx={{
                      borderRadius: 2,
                      p: 2,
                      zIndex: 2,
                      position: 'relative',
                    }}
                  >
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow sx={{}}>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          />

                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            Kansas State Tax is Withheld
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            Kansas State Tax is not Withheld
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody sx={{}}>
                        <TableRow sx={{ backgroundColor: 'transparent' }}>
                          <TableCell
                            sx={{
                              backgroundColor: 'transparent',
                              textAlign: 'center',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Taxes / Payments
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            More than $0 in taxes
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            $10 or more in payments
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Filing Method
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Additional Form
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Form KW-3 <br />
                            (Annual Withholding Tax Return)
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            Form KW-3 <br />
                            (Annual Withholding Tax Return)
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                            id="int"
                          >
                            Due Date
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid
            size={12}
            sx={{
              textAlign: 'center',
              mb: 4,
              mt: { xs: 6, sm: 0 },
              position: { xs: 'relative', sm: 'static' },
            }}
          >
            <Box
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: { xs: 'flex', sm: 'grid', md: 'grid' },
                gridTemplateColumns: 'auto auto ',
                columnGap: 1,
                placeContent: 'start',
                m: { xs: 3, sm: 0 },
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  justifyContent: 'center',
                  alignContent: 'center',
                  borderRadius: '50%',
                  backgroundColor: '#efefef',
                  height: 150,
                  width: 150,
                  position: { xs: 'absolute', sm: 'relative', md: 'relative' },
                  left: { md: 55, sm: 40, xs: 90 },
                  zIndex: 2,
                  top: { xs: -80, sm: 0 },
                  p: 3,
                  m: '0',
                  boxShadow:
                    'rgba(154, 154, 163, 0.25) 0px 30px 50px -12px inset, rgba(255, 255, 255, 0.1) 0px 18px 26px -18px inset',
                }}
              >
                <Box
                  sx={{
                    width: '34px !important',
                    height: '27px !important',
                    m: 'auto',
                    display: 'flex',
                    textAlign: 'center',
                    justifyContent: 'center',
                    mb: 0.5,
                    // position: 'relative',
                    // mb: 2,

                    // alignSelf: 'center',
                    // textAlign: 'center',

                    '& .state-flag': {
                      // position: 'absolute',
                      height: '100%',
                      width: '100%',
                      // inset: '0px',
                      // color: 'transparent',
                    },
                  }}
                >
                  <img
                    srcSet="/assets/images/state-flag/kansas-flag.svg"
                    loading="lazy"
                    alt="kansas"
                    width="100%"
                    height="100%"
                    className="state-flag"
                  />
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 700,
                    justifyContent: 'center',
                    alignItems: 'center',
                    m: 0,
                    // display: 'flex',
                  }}
                >
                  1099-INT
                </Typography>
              </Box>
              <Box
                sx={{
                  backgroundColor: '#f0f2f9',

                  borderRadius: 4,
                  justifyContent: { xs: 'center' },
                  position: 'relative',
                  width: { xs: 331, sm: 'auto' },
                  right: { xs: 23, sm: 'auto' },
                }}
              >
                <Box
                  component="div"
                  sx={{ mb: 0, mx: 4, position: 'relative' }}
                  className="rectange-state rectange-state-left"
                >
                  <TableContainer
                    sx={{
                      borderRadius: 2,
                      p: 2,
                      zIndex: 2,
                      position: 'relative',
                    }}
                  >
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow sx={{}}>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          />

                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            Kansas State Tax is Withheld
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            Kansas State Tax is not Withheld
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody sx={{}}>
                        <TableRow sx={{ backgroundColor: 'transparent' }}>
                          <TableCell
                            sx={{
                              backgroundColor: 'transparent',
                              textAlign: 'center',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Taxes / Payments
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            More than $0 in taxes
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            $10 or more in payments($600 or more in certain
                            circumstances)
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Filing Method
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Additional Form
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Form KW-3
                            <br /> (Annual Withholding Tax Return)
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            Form KW-3 <br />
                            (Annual Withholding Tax Return)
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                            id="1099k"
                          >
                            Due Date
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid
            size={12}
            sx={{
              textAlign: 'center',
              mb: 4,
              mt: { xs: 6, sm: 0 },
              position: { xs: 'relative', sm: 'static' },
            }}
          >
            <Box
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: { xs: 'flex', sm: 'grid', md: 'grid' },
                gridTemplateColumns: 'auto auto ',
                columnGap: 1,
                placeContent: 'start',
                m: { xs: 3, sm: 0 },
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  justifyContent: 'center',
                  alignContent: 'center',
                  borderRadius: '50%',
                  backgroundColor: '#efefef',
                  height: 150,
                  width: 150,
                  position: { xs: 'absolute', sm: 'relative', md: 'relative' },
                  left: { md: 55, sm: 40, xs: 90 },
                  zIndex: 2,
                  top: { xs: -80, sm: 0 },
                  p: 3,
                  m: '0',
                  boxShadow:
                    'rgba(154, 154, 163, 0.25) 0px 30px 50px -12px inset, rgba(255, 255, 255, 0.1) 0px 18px 26px -18px inset',
                }}
              >
                <Box
                  sx={{
                    width: '34px !important',
                    height: '27px !important',
                    m: 'auto',
                    display: 'flex',
                    textAlign: 'center',
                    justifyContent: 'center',
                    mb: 0.5,

                    '& .state-flag': {
                      height: '100%',
                      width: '100%',
                    },
                  }}
                >
                  <img
                    srcSet="/assets/images/state-flag/kansas-flag.svg"
                    loading="lazy"
                    alt="kansas"
                    width="100%"
                    height="100%"
                    className="state-flag"
                  />
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 700,
                    justifyContent: 'center',
                    alignItems: 'center',
                    m: 0,
                  }}
                >
                  1099-K
                </Typography>
              </Box>
              <Box
                sx={{
                  backgroundColor: '#f0f2f9',

                  borderRadius: 4,
                  justifyContent: { xs: 'center' },
                  position: 'relative',
                  width: { xs: 331, sm: 'auto' },
                  right: { xs: 23, sm: 'auto' },
                }}
              >
                <Box
                  component="div"
                  sx={{ mb: 0, mx: 4, position: 'relative' }}
                  className="rectange-state rectange-state-left"
                >
                  <TableContainer
                    sx={{
                      borderRadius: 2,
                      p: 2,
                      zIndex: 2,
                      position: 'relative',
                    }}
                  >
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow sx={{}}>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          />

                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            Kansas State Tax is Withheld
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            Kansas State Tax is not Withheld
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody sx={{}}>
                        <TableRow sx={{ backgroundColor: 'transparent' }}>
                          <TableCell
                            sx={{
                              backgroundColor: 'transparent',
                              textAlign: 'center',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Taxes / Payments
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            More than $0 in taxes
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'left',
                              backgroundColor: 'transparent',
                            }}
                          >
                            <ul>
                              <li>
                                $600 or more for third-party network
                                transactions.
                              </li>
                              <li>
                                All amounts for payment card transactions.
                              </li>
                            </ul>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Filing Method
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Additional Form
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Form KW-3 <br />
                            (Annual Withholding Tax Return)
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            Form KW-3 <br />
                            (Annual Withholding Tax Return)
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                            id="oid"
                          >
                            Due Date
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid
            size={12}
            sx={{
              textAlign: 'center',
              mb: 4,
              mt: { xs: 6, sm: 0 },
              position: { xs: 'relative', sm: 'static' },
            }}
          >
            <Box
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: { xs: 'flex', sm: 'grid', md: 'grid' },
                gridTemplateColumns: 'auto auto ',
                columnGap: 1,
                placeContent: 'start',
                m: { xs: 3, sm: 0 },
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  justifyContent: 'center',
                  alignContent: 'center',
                  borderRadius: '50%',
                  backgroundColor: '#efefef',
                  height: 150,
                  width: 150,
                  position: { xs: 'absolute', sm: 'relative', md: 'relative' },
                  left: { md: 55, sm: 40, xs: 90 },
                  zIndex: 2,
                  top: { xs: -80, sm: 0 },
                  p: 3,
                  m: '0',
                  boxShadow:
                    'rgba(154, 154, 163, 0.25) 0px 30px 50px -12px inset, rgba(255, 255, 255, 0.1) 0px 18px 26px -18px inset',
                }}
              >
                <Box
                  sx={{
                    width: '34px !important',
                    height: '27px !important',
                    m: 'auto',
                    display: 'flex',
                    textAlign: 'center',
                    justifyContent: 'center',
                    mb: 0.5,
                    // position: 'relative',
                    // mb: 2,

                    // alignSelf: 'center',
                    // textAlign: 'center',

                    '& .state-flag': {
                      // position: 'absolute',
                      height: '100%',
                      width: '100%',
                      // inset: '0px',
                      // color: 'transparent',
                    },
                  }}
                >
                  <img
                    srcSet="/assets/images/state-flag/kansas-flag.svg"
                    loading="lazy"
                    alt="kansas"
                    width="100%"
                    height="100%"
                    className="state-flag"
                  />
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 700,
                    justifyContent: 'center',
                    alignItems: 'center',
                    m: 0,
                    // display: 'flex',
                  }}
                >
                  1099-OID
                </Typography>
              </Box>
              <Box
                sx={{
                  backgroundColor: '#f0f2f9',

                  borderRadius: 4,
                  justifyContent: { xs: 'center' },
                  position: 'relative',
                  width: { xs: 331, sm: 'auto' },
                  right: { xs: 23, sm: 'auto' },
                }}
              >
                <Box
                  component="div"
                  sx={{ mb: 0, mx: 4, position: 'relative' }}
                  className="rectange-state rectange-state-left"
                >
                  <TableContainer
                    sx={{
                      borderRadius: 2,
                      p: 2,
                      zIndex: 2,
                      position: 'relative',
                    }}
                  >
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow sx={{}}>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          />

                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            Kansas State Tax is Withheld
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            Kansas State Tax is not Withheld
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody sx={{}}>
                        <TableRow sx={{ backgroundColor: 'transparent' }}>
                          <TableCell
                            sx={{
                              backgroundColor: 'transparent',
                              textAlign: 'center',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Taxes / Payments
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            More than $0 in taxes
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            $10 or more in payments
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Filing Method
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Additional Form
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Form KW-3 <br />
                            (Annual Withholding Tax Return)
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            Form KW-3 <br />
                            (Annual Withholding Tax Return)
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                            id="1099r"
                          >
                            Due Date
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid
            size={12}
            sx={{
              textAlign: 'center',
              mb: 4,
              mt: { xs: 6, sm: 0 },
              position: { xs: 'relative', sm: 'static' },
            }}
          >
            <Box
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: { xs: 'flex', sm: 'grid', md: 'grid' },
                gridTemplateColumns: 'auto auto ',
                columnGap: 1,
                placeContent: 'start',
                m: { xs: 3, sm: 0 },
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  justifyContent: 'center',
                  alignContent: 'center',
                  borderRadius: '50%',
                  backgroundColor: '#efefef',
                  height: 150,
                  width: 150,
                  position: { xs: 'absolute', sm: 'relative', md: 'relative' },
                  left: { md: 55, sm: 40, xs: 90 },
                  zIndex: 2,
                  top: { xs: -80, sm: 0 },
                  p: 3,
                  m: '0',
                  boxShadow:
                    'rgba(154, 154, 163, 0.25) 0px 30px 50px -12px inset, rgba(255, 255, 255, 0.1) 0px 18px 26px -18px inset',
                }}
              >
                <Box
                  sx={{
                    width: '34px !important',
                    height: '27px !important',
                    m: 'auto',
                    display: 'flex',
                    textAlign: 'center',
                    justifyContent: 'center',
                    mb: 0.5,

                    '& .state-flag': {
                      height: '100%',
                      width: '100%',
                    },
                  }}
                >
                  <img
                    srcSet="/assets/images/state-flag/kansas-flag.svg"
                    loading="lazy"
                    alt="kansas"
                    width="100%"
                    height="100%"
                    className="state-flag"
                  />
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 700,
                    justifyContent: 'center',
                    alignItems: 'center',
                    m: 0,
                  }}
                >
                  1099-R
                </Typography>
              </Box>
              <Box
                sx={{
                  backgroundColor: '#f0f2f9',

                  borderRadius: 4,
                  justifyContent: { xs: 'center' },
                  position: 'relative',
                  width: { xs: 331, sm: 'auto' },
                  right: { xs: 23, sm: 'auto' },
                }}
              >
                <Box
                  component="div"
                  sx={{ mb: 0, mx: 4, position: 'relative' }}
                  className="rectange-state rectange-state-left"
                >
                  <TableContainer
                    sx={{
                      borderRadius: 2,
                      p: 2,
                      zIndex: 2,
                      position: 'relative',
                    }}
                  >
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow sx={{}}>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          />

                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            Kansas State Tax is Withheld
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            Kansas State Tax is not Withheld
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody sx={{}}>
                        <TableRow sx={{ backgroundColor: 'transparent' }}>
                          <TableCell
                            sx={{
                              backgroundColor: 'transparent',
                              textAlign: 'center',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Taxes / Payments
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            More than $0 in taxes
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            $10 or more in payments
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Filing Method
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Additional Form
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Form KW-3 <br />
                            (Annual Withholding Tax Return)
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            Form KW-3 <br />
                            (Annual Withholding Tax Return)
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                            id="w2g"
                          >
                            Due Date
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid
            size={12}
            sx={{
              textAlign: 'center',
              mb: 4,
              mt: { xs: 6, sm: 0 },
              position: { xs: 'relative', sm: 'static' },
            }}
          >
            <Box
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: { xs: 'flex', sm: 'grid', md: 'grid' },
                gridTemplateColumns: 'auto auto ',
                columnGap: 1,
                placeContent: 'start',
                m: { xs: 3, sm: 0 },
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  justifyContent: 'center',
                  alignContent: 'center',
                  borderRadius: '50%',
                  backgroundColor: '#efefef',
                  height: 150,
                  width: 150,
                  position: { xs: 'absolute', sm: 'relative', md: 'relative' },
                  left: { md: 55, sm: 40, xs: 90 },
                  zIndex: 2,
                  top: { xs: -80, sm: 0 },
                  p: 3,
                  m: '0',
                  boxShadow:
                    'rgba(154, 154, 163, 0.25) 0px 30px 50px -12px inset, rgba(255, 255, 255, 0.1) 0px 18px 26px -18px inset',
                }}
              >
                <Box
                  sx={{
                    width: '34px !important',
                    height: '27px !important',
                    m: 'auto',
                    display: 'flex',
                    textAlign: 'center',
                    justifyContent: 'center',
                    mb: 0.5,
                    // position: 'relative',
                    // mb: 2,

                    // alignSelf: 'center',
                    // textAlign: 'center',

                    '& .state-flag': {
                      // position: 'absolute',
                      height: '100%',
                      width: '100%',
                      // inset: '0px',
                      // color: 'transparent',
                    },
                  }}
                >
                  <img
                    srcSet="/assets/images/state-flag/kansas-flag.svg"
                    loading="lazy"
                    alt="kansas"
                    width="100%"
                    height="100%"
                    className="state-flag"
                  />
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 700,
                    justifyContent: 'center',
                    alignItems: 'center',
                    m: 0,
                    // display: 'flex',
                  }}
                >
                  W-2G
                </Typography>
              </Box>
              <Box
                sx={{
                  backgroundColor: '#f0f2f9',

                  borderRadius: 4,
                  justifyContent: { xs: 'center' },
                  position: 'relative',
                  width: { xs: 331, sm: 'auto' },
                  right: { xs: 23, sm: 'auto' },
                }}
              >
                <Box
                  component="div"
                  sx={{ mb: 0, mx: 4, position: 'relative' }}
                  className="rectange-state rectange-state-left"
                >
                  <TableContainer
                    sx={{
                      borderRadius: 2,
                      p: 2,
                      zIndex: 2,
                      position: 'relative',
                    }}
                  >
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow sx={{}}>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          />

                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            Kansas State Tax is Withheld
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            Kansas State Tax is not Withheld
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody sx={{}}>
                        <TableRow sx={{ backgroundColor: 'transparent' }}>
                          <TableCell
                            sx={{
                              backgroundColor: 'transparent',
                              textAlign: 'center',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Taxes / Payments
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            More than $0 in taxes
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'left',
                              backgroundColor: 'transparent',
                            }}
                          >
                            <ul>
                              <li>
                                $600 or more from general gambling activities
                              </li>
                              <li>
                                $1,200 or more from bingo or slot machines
                              </li>
                              <li>$1,500 or more from keno</li>
                            </ul>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Filing Method
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Additional Form
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Form KW-3 <br />
                            (Annual Withholding Tax Return)
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            Form KW-3 <br />
                            (Annual Withholding Tax Return)
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Due Date
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid size={12} sx={{ textAlign: 'center' }}>
            <Typography
              variant="h3"
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 600,

                mb: 2,
                lineHeight: 1.5,
              }}
            >
              Get started with 1099 E-filing in Kansas today!
            </Typography>
            <Box sx={{ textAlign: 'center', mr: { xs: 0, md: 4 } }}>
              <Button
                variant="contained"
                className="btn-primary"
                sx={{
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                }}
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1099ks`}
              >
                Start Filing Now!{' '}
                {/* <Box
                      component={'span'}
                      sx={{ ml: 1, color: '#eaff00', fontWeight: 700 }}
                    >
                      Your W-2 Today!
                    </Box> */}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            direction={{ md: 'row', xs: 'column-reverse' }}
            sx={{ pt: 5, pb: 5 }}
          >
            <Grid
              size={{ xs: 12, sm: 6 }}
              sx={{
                textAlign: { md: 'left', xs: 'center' },
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
              }}
            >
              <Box sx={{ px: { md: 0, sm: 0, xs: 2 } }}>
                {' '}
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: { md: 3, sm: 1, xs: 0 },
                    pt: { md: 0, sm: 3 },
                    textAlign: { md: 'left', sm: 'center' },
                  }}
                >
                  Who Needs to File 1099 Forms in Kansas?
                </Typography>
                <Typography variant="body1">
                  Businesses operating in Kansas that withhold state income tax
                  are required to file 1099 forms for the 2025 tax year. This
                  rule applies to all businesses, regardless of size—from small
                  companies to large enterprises. Filing accurately and on time
                  ensures compliance with Kansas state regulations and prevents
                  penalties.
                </Typography>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }} sx={{ textAlign: 'center' }}>
              <Box>
                <picture>
                  <source srcSet="/assets/images/who-file-ks-img.webp" />
                  <source srcSet="/assets/images/who-file-ks-img.png" />
                  <img
                    src="/assets/images/who-file-ks-img.png"
                    alt="Who Needs to File 1099 Forms in Kansas?"
                    className="img-responsive img-shadow"
                    loading="lazy"
                    width={400}
                    height={400}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ py: 6 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mt: 4,
              mb: 2,
              textAlign: 'center',
            }}
          >
            Why Choose TaxZerone for Kansas 1099 Filing?
          </Typography>
          <Typography
            variant="body1"
            sx={{ px: { md: 14, sm: 3, xs: 2 }, textAlign: 'center', mb: 3 }}
          >
            Enhance your kansas 1099 filing experience with TaxZerone. Our
            intuitive platform guarantees a smooth process, allowing for precise
            and timely submissions
          </Typography>
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  backgroundColor: '#f0f2f9',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  p: 4,
                  borderRadius: 4,
                  textAlign: 'center',
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/easy-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/easy-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/easy-icon.png"
                      alt="Quick & Easy Process"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    fontSize: '18px !important',
                    mt: 2,
                    mb: 1,
                  }}
                >
                  Quick & Easy Process
                </Typography>
                <Typography variant="body1">
                  {' '}
                  Submit your 1099 forms in just minutes with our streamlined
                  3-step system.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  backgroundColor: '#f0f2f9',
                  borderColor: '#76ce97',
                  borderWidth: 3,
                  p: 4,
                  borderRadius: 4,
                  textAlign: 'center',
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/lowest-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/lowest-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/lowest-icon.png"
                      alt="Budget-Friendly Pricing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    fontSize: '18px !important',
                    mt: 2,
                    mb: 1,
                  }}
                >
                  Budget-Friendly Pricing
                </Typography>
                <Typography variant="body1">
                  {' '}
                  File your state 1099 forms for only <b>$0.99</b> each—no
                  hidden charges or extra costs.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  backgroundColor: '#f0f2f9',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  p: 4,
                  borderRadius: 4,
                  textAlign: 'center',
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/upload-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/upload-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/upload-icon.png"
                      alt="Time-Saving Bulk Upload"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    fontSize: '18px !important',
                    mb: 1,
                    mt: 2,
                  }}
                >
                  Time-Saving Bulk Upload
                </Typography>
                <Typography variant="body1">
                  {' '}
                  Effortlessly upload multiple forms at once, reducing manual
                  work.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  backgroundColor: '#f0f2f9',
                  p: 4,
                  borderRadius: 4,
                  textAlign: 'center',
                  minHeight: '100%',
                  borderWidth: 3,
                  borderColor: '#76ce97',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/support-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/support-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/support-icon.png"
                      alt="Reliable Expert Assistance"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    fontSize: '18px !important',
                    mb: 1,
                    mt: 2,
                  }}
                >
                  Reliable Expert Assistance
                </Typography>
                <Typography variant="body1">
                  {' '}
                  Our dedicated support team is here to help with any questions
                  or concerns.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Box
        component="section"
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Simplify Your Kansas 1099 Filing with TaxZerone!
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 2,
            lineHeight: 1.5,
          }}
        >
          TaxZerone simplifies your Kansas 1099 submissions with a hassle-free
          process.{' '}
          <Hidden smDown>
            <br />
          </Hidden>
          Our platform supports Electronic (Direct)Filing and the Combined
          Federal/State Filing (CF/SF){' '}
          <Hidden smDown>
            <br />
          </Hidden>
          program, ensuring accuracy, speed, and compliance.
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1099ks`}
          >
            Get Started Today
          </Button>
        </Box>
      </Box>
      <Container component="section" maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
            className="responsive"
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. What forms are required for Kansas state tax filing?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      Businesses in Kansas must file various 1099 forms to
                      report state income tax withholding. These include{' '}
                      <Link
                        href="/information-returns/efile-irs-form-1099-nec/"
                        sx={{ color: '#0202ff' }}
                      >
                        1099-NEC
                      </Link>{' '}
                      for non-employee compensation,{' '}
                      <Link
                        href="/information-returns/efile-irs-form-1099-misc/"
                        sx={{ color: '#0202ff' }}
                      >
                        1099-MISC
                      </Link>{' '}
                      for miscellaneous income, as well as{' '}
                      <Link
                        href="/information-returns/efile-irs-form-1099-b/"
                        sx={{ color: '#0202ff' }}
                      >
                        1099-B
                      </Link>
                      ,{' '}
                      <Link
                        href="/information-returns/efile-irs-form-1099-div/"
                        sx={{ color: '#0202ff' }}
                      >
                        1099-DIV
                      </Link>
                      ,{' '}
                      <Link
                        href="/information-returns/efile-irs-form-1099-g/"
                        sx={{ color: '#0202ff' }}
                      >
                        1099-G
                      </Link>
                      ,{' '}
                      <Link
                        href="/information-returns/efile-irs-form-1099-int/"
                        sx={{ color: '#0202ff' }}
                      >
                        1099-INT
                      </Link>
                      ,{' '}
                      <Link
                        href="/information-returns/efile-irs-form-1099-k/"
                        sx={{ color: '#0202ff' }}
                      >
                        1099-K
                      </Link>
                      ,{' '}
                      <Link
                        href="/information-returns/efile-irs-form-1099-oid/"
                        sx={{ color: '#0202ff' }}
                      >
                        1099-OID
                      </Link>
                      ,{' '}
                      <Link
                        href="/information-returns/efile-irs-form-1099-r/"
                        sx={{ color: '#0202ff' }}
                      >
                        1099-R
                      </Link>
                      , and{' '}
                      <Link
                        href="/information-returns/efile-irs-form-w-2g/"
                        sx={{ color: '#0202ff' }}
                      >
                        W-2G
                      </Link>
                      . Each form is used to report specific types of income.
                      Filing these forms ensures compliance with the Kansas
                      Department of Revenue.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. Is Form KW-3 required for Kansas state filing?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1, mb: 0 }}>
                      Yes, businesses in Kansas are required to file Form KW-3,
                      the Kansas Annual Withholding Tax Reconciliation Form.
                      This form is used to report and reconcile state income tax
                      withheld from employees&apos; wages and other reportable
                      payments. Timely filing of this form ensures compliance
                      with the Kansas Department of Revenue and helps businesses
                      avoid penalties.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. Who is required to file 1099 forms in Kansas?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      Any business that withholds Kansas state income tax from
                      payments must file the applicable 1099 forms with the
                      Kansas Department of Revenue. This includes payments for
                      non-employee compensation, rents, royalties, or other
                      taxable income. Accurate filings ensure businesses remain
                      compliant and avoid potential penalties. Check specific
                      thresholds and criteria for each form type.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. What are the Kansas 1099 filing deadlines for the 2025 tax
                  year?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      For the 2025 tax year, Kansas 1099 forms that include
                      state income tax withholding must be filed by January 31,
                      2026, which aligns with federal deadlines. Forms without
                      state withholding are also due on this date. If the
                      deadline falls on a weekend or holiday, it extends to the
                      next business day. Filing on time helps avoid penalties.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  5. What are the consequences of missing Kansas 1099 filing
                  deadlines?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      A payer who intentionally fails to provide a payee with a
                      1099 by{' '}
                      <span style={{ fontWeight: 600 }}>February 02, 2026</span>{' '}
                      may face a fine of up to $100 per occurrence.
                      Additionally, a payer who fails to submit the
                      &quot;State&quot; copy of the 1099 to the Department of
                      Revenue by{' '}
                      <span style={{ fontWeight: 600 }}>February 02, 2026</span>{' '}
                      may incur a penalty of $50 for each unsubmitted 1099 form
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  6. Where should Kansas 1099 forms be sent?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1, mb: 1 }}>
                      Completed 1099 forms for Kansas state filing should be
                      mailed to:
                    </Typography>
                    <Box sx={{ textAlign: 'left' }}>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: 600, mb: 0.8 }}
                      >
                        {' '}
                        <MailOutlineOutlinedIcon
                          sx={{
                            position: 'relative',
                            ml: 0,
                            mr: 0.5,
                            mb: -1,
                            fontSize: 28,
                          }}
                        />{' '}
                        Mailing Address:
                      </Typography>
                      <Box
                        component="div"
                        sx={{ textAlign: 'left', fontSize: '15px important' }}
                      >
                        <Typography
                          variant="body2"
                          sx={{ fontStyle: 'italic' }}
                        >
                          <span style={{ fontWeight: 600 }}>
                            Kansas Department Of Revenue
                          </span>
                          <br />
                          PO BOX 3506
                          <br />
                          Topeka, KS 66625-3506
                        </Typography>
                        <Alert severity="warning" icon={false} sx={{ mt: 2 }}>
                          <b>Note:</b> The IRS recommends e-filing for a fast,
                          secure and more convenient experience.
                        </Alert>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>{' '}
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default Form1099Kansas;
